import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';

import { Component, computed, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { dsDtos } from '@vectronic/openApi-admin';
import { BeltDialogComponent, BeltInfoComponent } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';

@Component({
  selector: 'table-datatable-belt',
  templateUrl: './datatable-belt.component.html',
  styleUrls: ['./datatable-belt.component.scss'],
  imports: [
    MatButtonModule,
    CdkConnectedOverlay,
    CdkOverlayOrigin,
    MatCardModule,
    BeltInfoComponent,
  ],
})
export class DatatableBeltComponent {
  belt = input<dsDtos.Belt>();
  idDevice = input<number>();
  isCompactModeActivated = input<boolean>();

  isOpen = signal(false);

  isBeltEmpty = computed(() => !this.belt() || !Object.entries(this.belt()).length);

  private dialogService = inject(DialogService);

  onClickBelt() {
    this.dialogService.open(BeltDialogComponent, {
      data: {
        belt: this.belt(),
        idDevice: this.idDevice(),
      },
    });
  }

  onMouseOver() {
    this.isOpen.set(true);
  }

  onMouseOut() {
    this.isOpen.set(false);
  }
}
